import { render, staticRenderFns } from "./UploadTest.vue?vue&type=template&id=9900e556&"
import script from "./UploadTest.vue?vue&type=script&lang=js&"
export * from "./UploadTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports